export { symbolIdentifier } from './symbol-id';
